// extracted by mini-css-extract-plugin
export var bodySections = "_aa-8";
export var gray = "_aa-7";
export var green = "_aa-4";
export var iconContainer = "_aa-9";
export var iconWidgetContainer = "_aa-1";
export var phoneIcon = "_aa-2";
export var red = "_aa-5";
export var statusDot = "_aa-3";
export var widgetContainer = "_aa-0";
export var yellow = "_aa-6";